import React, { FunctionComponent } from 'react';
import ArrowButtonProps from 'components/Buttons/Arrow/Props';
import styles from './Arrow.module.scss';

const NextButton: FunctionComponent<ArrowButtonProps> = ({ onClick, className, style, arrowClassName }) => {
	return (
		<button
			onClick={onClick}
			className={`${className} ${styles.ArrowButton}`} 
			>
			<i
				className={`${styles.Arrow} ${styles.Right} ${arrowClassName}`}
				style={style} 
				/>
		</button>
	);
};

NextButton.defaultProps = {
	className: '',
	onClick: () => null,
};

export default NextButton;
